<template>
  <div class="custom-table">
      <!-- selectable
      select-mode="single" -->
    <b-table
      ref="selectableTable"
      striped
      responsive
      :items="items"
      :fields="fields"
      :busy="displayLoading"
      @row-clicked="onRowClicked"
      class="mb-0"
    >
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
      <!-- full detail on click -->
      <!-- <template #row-details="row">
        <b-card>
          <b-row class="mb-2">
            <b-col
              md="4"
              class="mb-1"
              v-for="(item, index) in getObjectKeys(row.item)"
              :key="index"
            >
              <strong>{{ getLabelField(item, row.fields) }} : </strong>{{ getRowValueField(item, row.fields, row.item[item]) }}
            </b-col>
          </b-row>
          <b-button
            size="sm"
            variant="outline-success"
            @click="onEdit(row.item)"
            v-if="hasEditButton"
          >
            Editar
          </b-button>
          <b-button
            size="sm"
            variant="outline-danger"
            @click="onDelete(row.item)"
            v-if="hasDeleteButton"
          >
            <feather-icon icon="TrashIcon" />
          </b-button>
        </b-card>
      </template> -->

      <!-- <template #cell(avatar)="data">
        <b-avatar :src="data.value" />
      </template>

      <template #cell(status)="data">
        <b-badge :variant="status[1][data.value]">
          {{ status[0][data.value] }}
        </b-badge>
      </template> -->

      <!-- <template #cell(active)="data">
        <b-badge :variant="getActiveBadge(data.value)">
          {{ getActiveBadgeLabel(data.value) }}
        </b-badge>
      </template> -->

      <!-- <template #cell(date)="data">
        {{getDateFormat(data)}}
      </template> -->

      <!-- Optional default data cell scoped slot -->
      <!-- <template #cell()="data">
        {{data.value}}
      </template> -->

      <template #cell()="data">
        <template v-if="data.field.type === 'avatar'">
          <b-avatar :src="data.value" />
        </template>
        <template v-else-if="data.field.type === 'phone'">
          {{getPhoneFormat(data.value)}}
        </template>          
        <template v-else-if="data.field.type === 'boolean'">
          <b-badge :variant="getActiveBadge(data.value)">
          {{ getActiveBadgeLabel(data.value) }}
        </b-badge>
        </template>
        <template v-else-if="data.field.type === 'date'">
          {{getDateFormat(data.value)}}
        </template>
        <template v-else-if="data.field.type === 'thumb'">
          <img :src="data.value">
        </template>
        <template v-else-if="data.field.type === 'object'">
          {{getDataObject(data.value)}}
        </template>
        <template v-else-if="data.field.type === 'array'">
          <span v-for="(val, index) in data.value" :key="index">{{getDataObject(val)}}, </span>
        </template>
        <template v-else>
          {{data.value}}
        </template>
      </template>

      <!-- <template v-else-if="data.field.type === 'delete'">
          <b-button
            size="sm"
            variant="outline-danger"
            @click="onDelete(row.item)"
            v-if="hasDeleteButton"
          >
            <feather-icon icon="TrashIcon" />
          </b-button>
        </template>
        <template v-else-if="data.field.type === 'edit'">
           <b-button
            size="sm"
            variant="outline-success"
            @click="onEdit(row.item)"
            v-if="hasEditButton"
          >
            Editar
          </b-button>
        </template> -->

      <!-- <template #cell(boolean)="data">
        {{getDateFormat(data)}}
      </template> -->
      <!-- Buttons -->
      <template #cell(action_buttons)="data">
        <b-button size="sm" variant="outline-success" @click="onEdit(data.item)" v-if="hasEditButton">
          Editar
        </b-button>
        <b-button size="sm" variant="outline-danger" @click="onDelete(data.item)" v-if="hasDeleteButton">
          Deletar
        </b-button>
      </template>
    </b-table>

    <b-card-body class="d-flex justify-content-between flex-wrap pt-1">
      <!-- <b-col md="4"></b-col> -->
      <b-col md="3">
        <!-- pagination -->
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="limit"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
            @change="handleChangePage"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
      </b-col>
      <b-col md="4">
        <!-- page length -->
        <b-form-group
          label="Registro por página"
          label-cols="5"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          
        >
          <b-form-select
            id="perPageSelect"
            v-model="limit"
            size="sm"
            inline
            :options="pageOptions"
          />
        </b-form-group>
      </b-col>
    </b-card-body>
  </div>
</template>

<script>
import {
  BTable,
  //   BFormCheckbox,
  BButton,
  BCard,
  BRow,
  BCol,
  BAvatar,
  BBadge,
  BCardBody,
  BPagination,
  BFormGroup,
  BFormSelect,
  BSpinner,
} from "bootstrap-vue";
import AppConstants from "@/appConstants";
import convertDatetimeHelper from '@/helpers/convert-datetime-helper';

export default {
  components: {
    BTable,
    // BFormCheckbox,
    /* eslint-disable */
    BButton,
    /* eslint-disable */
    BCard,
    /* eslint-disable */
    BRow,
    /* eslint-disable */
    BCol,
    BBadge,
    BAvatar,
    BCardBody,
    BPagination,
    /* eslint-disable */
    BFormGroup,
    /* eslint-disable */
    BFormSelect,
    BSpinner,
  },
  props: {
    fields: {
      type: Array,
      default: () => {},
    },
    items: {
      type: Array,
      default: () => {},
    },
    totalRows: {
      type: Number,
      default: 0,
    },
    limit: {
      type: Number,
    },
    displayLoading: {
      type: Boolean,
      default: false,
    },
    hasEditButton: Boolean,
    hasDeleteButton: Boolean,
  },
  data() {
    return {
      phoneMask: {
          phone: true,
          phoneRegionCode: 'BR',
        },
      pageOptions: [],
      currentPage: 1,
      currentRowDetail: null,
      // fields: ['show_details', 'id', { key: 'avatar', label: 'Avatar' }, { key: 'status', label: 'Status' }],
      /* eslint-disable global-require */
      status: [
        {
          1: "Current",
          2: "Professional",
          3: "Rejected",
          4: "Resigned",
          5: "Applied",
        },
        {
          1: "light-primary",
          2: "light-success",
          3: "light-danger",
          4: "light-warning",
          5: "light-info",
        },
      ],
    };
  },
  created() {
    this.pageOptions = AppConstants.PAGINATOR_DEFAULT_PAGE_SIZE_OPTIONS;
  },
  methods: {
    getRowValueField(item, rowFields, value) {
      const index = rowFields.findIndex(r => r.key == item);
      if (index >= 0) {
        if (rowFields[index].type) {
          if (rowFields[index].type == 'boolean') {
            return this.getActiveBadgeLabel(value);
          }
          if (rowFields[index].type == 'date') {
            return this.getDateFormat(value);
          }
          if (rowFields[index].type == 'object') {
            return this.getDataObject(value);
          }
          if (rowFields[index].type == 'array') {
            return value.map(v => this.getDataObject(v));
          }
        }
      }
      return value;
    },
    getLabelField(item, rowFields) {
      const index = rowFields.findIndex(r => r.key == item);
      if (index >= 0) {
        return rowFields[index].label
      }
      return item;
    },
    getDataObject(data) {
      if (data.name) {
        return data.name;
      }
      return data;
    },
    getPhoneFormat(phone) {
      return phone;
    },
    getDateFormat(dt) {
      return convertDatetimeHelper.convertStringToDateTime(dt);
    },
    onchangeCheckbox(t) {
      console.log(t);
      t.toggleDetails();
    },
    getActiveBadgeLabel(active) {
      if (active) {
        return "Sim";
      }
      return "Não";
    },
    getActiveBadge(active) {
      if (active) {
        return "light-success";
      }
      return "light-danger";
    },
    handleChangePage(page) {
      console.log("page: ", page);
      this.$emit('changePage', page);
    },
    getObjectKeys(object) {
      return Object.keys(object);
    },
    onRowClicked(row) {
      // console.log(row);
      this.$set(row, "_showDetails", !row._showDetails);
      if (this.currentRowDetail) {
        if (this.currentRowDetail.id != row.id) {
          if (this.currentRowDetail._showDetails) {
            this.$set(this.currentRowDetail, "_showDetails", !this.currentRowDetail._showDetails);
          }
        }
      }
      this.currentRowDetail = row;
    },
    onEdit(data) {
      console.log('onEdit: ', data);
      this.$emit('onEdit', data);
    },
    onDelete(data) {
      console.log("onDelete: " + data);
      this.$emit('onDelete', data);
    },
  },
};
</script>

<style>
.custom-table {
  margin: 10px 0px;
}
</style>
